import React from "react";

const icon = (className) => () => (
  <i className={className} aria-hidden="true" />
);

export const Poor = icon("ri-emotion-unhappy-line");
export const Average = icon("ri-emotion-normal-line");
export const Good = icon("ri-emotion-happy-line");
export const Happy = icon("ri-emotion-laugh-line");
export const Excellent = icon("ri-star-smile-line");
